<template>
  <div>
    <v-toolbar flat color="white" class= "pt-3">
      <h1 class="heading dark-grey--text px-2 py-2">Access Point Group: {{accessPointGroupInfo.name}}</h1>
    </v-toolbar>

    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>

    <div v-if="displayContents('tags')">
      <tagscomponent
      :accessPointGroupId="this.$route.params.accessPointGroupId"
      :isloading="isLoading"
    ></tagscomponent>
    </div>
  <div v-if="displayContents('accessPoints')">
      <accesspointscomponent 
      :isloading="isLoading"
       :accessPointGroupId="this.$route.params.accessPointGroupId"
        @accessPointsSaved="fetchAccessPointsByGroup()"
    ></accesspointscomponent>  
  </div>
   <div v-if="displayContents('locationNetworksLocations')">
      <locationnetworkslocations
        :locationnetworkslocations="locationNetworksLocations"
        @locationnetworkslocations="fetchLocationsByGroup()"
        @locationSaved="fetchLocationsByGroup()"
      ></locationnetworkslocations>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
import Tags from "@/components/Tags.vue";
import AccessPoints from "@/components/AccessPoints.vue";
import LocationNetworksLocations from "@/components/Locations/LocationNetworksLocations.vue";

export default {
  props: ["accesspointgroupsummary", "totalitems"],
  components: {
     tagscomponent: Tags,
     accesspointscomponent: AccessPoints,
     locationnetworkslocations: LocationNetworksLocations
  },
  data() {
    return {
      tags: [],
      locationNetworksLocations: [],
      accessPoints: [],
      accessPointGroupInfo: [],
            associateDialog: false,
            name: "",
            isloading:true,
            loading: false, 
            expand: false,
            search: "",
            dialog: false,
            newDialog: false,
            pagination: {},
            editedIndex: -1,
            editedItem: {
              locationNodeId: null,
      name: "",
      isActive: true,
      isDeleted: false
    },
    defaultItem: {
      name: "",
      locationNodeId: null,
      isActive: true,
      isDeleted:false
    },
    headers: [
      {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
      
    ],
      activeTabName:'',
      tabs: [        
        { name: "tags", displayName: "Tags" },
        { name: "accessPoints", displayName: "Access Points" },
        { name: "locationNetworksLocations", displayName: "Associated Locations" }             
      ]
    };
  },
  created() {
    this.initialize();
  },
  async mounted() {
      this.setActiveTabName('tags')
  },
  computed: {
         pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
    },
  methods: {
    // fetchTagsByGroup() {
    //   Api()
    //     .get("/accessPointGroupTags/getTags/" + this.$route.params.accessPointGroupId)
    //     .then(response => {
    //       this.tags = response.data;
          
    //     });
    // },
     fetchAccessPointsByGroup() {
      Api()
        .get("/accessPointAccessPointGroups/getAccessPoints/" + this.$route.params.accessPointGroupId)
        .then(response => {
          this.accessPoints = response.data;
          console.log(this.accessPoints)
        });
    },
    fetchLocationsByGroup() {
      Api()
        .get("/Locations/showByAccessPointGroup/" + this.$route.params.accessPointGroupId)
        .then(response => {
          this.locationNetworksLocations = response.data;
        });
    },
    getAccessPointGroupInfo() {
      Api()
        .get("/accessPointGroups/getOne/" + this.$route.params.accessPointGroupId)
        .then(response => {
          this.accessPointGroupInfo = response.data;
        });
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    
    initialize() {
      this.getAccessPointGroupInfo();
      // this.fetchTagsByGroup();
      this.fetchAccessPointsByGroup();
      this.fetchLocationsByGroup();   
    },  
         
  }
};
</script>
